var __rspack_ns_object = JSON.parse('{"Image":"画像","Layout":"レイアウト","More":"もっと","Next":"次へ","Play":"プレイ","Previous":"前へ","Reset":"リセット","Stop":"ストップ"}')